export function unwrapHttp(res) {
  if (res && typeof res === "object" && "data" in res && !("meta" in res)) {
    return res.data;
  }
  return res;
}

export function errorToMessage(err, fallback = "Error al cargar insumos.") {
  return (
    err?.response?.data?.detail ||
    err?.response?.data?.message ||
    err?.data?.message ||
    err?.message ||
    fallback
  );
}
